export const brl = (n) => {
  const value = Number(n || 0);
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR");
  } catch { return ""; }
};

export const formatDateTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("pt-BR")} ${d.toLocaleTimeString("pt-BR", {hour:"2-digit", minute:"2-digit"})}`;
  } catch { return ""; }
};

export const statusLabel = (s) => ({
  aguardando_pagamento: "Aguardando pagamento",
  pago: "Pago",
  em_separacao: "Em separação",
  enviado: "Enviado",
  entregue: "Entregue",
  cancelado: "Cancelado",
  devolvido: "Devolvido",
}[s] || s);

export const statusColor = (s) => ({
  aguardando_pagamento: "bg-amber-100 text-amber-700 border-amber-200",
  pago: "bg-sky-100 text-sky-700 border-sky-200",
  em_separacao: "bg-violet-100 text-violet-700 border-violet-200",
  enviado: "bg-indigo-100 text-indigo-700 border-indigo-200",
  entregue: "bg-emerald-100 text-emerald-700 border-emerald-200",
  cancelado: "bg-rose-100 text-rose-700 border-rose-200",
  devolvido: "bg-neutral-200 text-neutral-700 border-neutral-300",
}[s] || "bg-gray-100 text-gray-700 border-gray-200");

export const maskCPF = (v) => (v||"").replace(/\D/g,"").slice(0,11).replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})$/,"$1-$2");
export const maskCEP = (v) => (v||"").replace(/\D/g,"").slice(0,8).replace(/(\d{5})(\d)/,"$1-$2");
export const maskPhone = (v) => (v||"").replace(/\D/g,"").slice(0,11).replace(/(\d{2})(\d)/,"($1) $2").replace(/(\d{5})(\d)/,"$1-$2");
